$(function () {
    var formElement = document.getElementById('js-slider-form');
    if (formElement) {
        var slideContainer = formElement.querySelector('.interview__slider'),
            controlsContainer = formElement.querySelector('.interview__slider_info'),
            slider = new FormSlider(slideContainer, controlsContainer);

        slider.init();

        var form = new TurboForm(formElement, {
            errorClassForGroup: 'form__group--error',
            fieldLineClass: 'form__group',
            errorBoxSelector: '.js-form-error-box',
        });

        form.showSuccessMessage = function (message) {
            var successBlock = $(this.form).find('.form__success');

            successBlock.find('.form__success_title').text(this.response.name + ', Ваша заявка принята.');
            successBlock.find('.form__success_text').html(message);
            successBlock.slideDown();
            $(this.form).find('.interview__slider').slideUp();
            YM_GOAL('QUIZ_FORM');
        };

        form.showErrorMessage = function (message) {
            if (this.errorBox) {
                this.errorBox.textContent = message;
                this.errorBox.style.display = 'block';
            }
        };

        form.showPreloader = function () {
            this.form.classList.add('form--sending');

            var form = this.form;
            // собираем ответы на вопросы
            var options_groups = this.form.querySelectorAll('.interview__slide_options'),
                result = [];
            options_groups.forEach(function (item) {
                var title = item.previousElementSibling.textContent.trim();
                var group_name = item.querySelector('input').name;
                var answer = form.elements.namedItem(group_name).value;
                result.push(title + ' - ' + answer);
            });
            form.elements['quiz'].value = '<br>' + result.join('<br>');
        };

        form.hidePreloader = function () {
            this.form.classList.remove('form--sending');
        };

        $('.js-reset-quiz').on('click', function (e) {
            e.preventDefault();
            slider.init();
            form.reset();
            $(form.form).find('.form__success').slideUp();
            $(form.form).find('.interview__slider').slideDown();
        });

    }
});
